
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1rylw_9",
  "input": "awsui_input_2rhyz_1rylw_13",
  "input-readonly": "awsui_input-readonly_2rhyz_1rylw_62",
  "input-invalid": "awsui_input-invalid_2rhyz_1rylw_106",
  "input-warning": "awsui_input-warning_2rhyz_1rylw_109",
  "input-type-search": "awsui_input-type-search_2rhyz_1rylw_112",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1rylw_122",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1rylw_125",
  "input-container": "awsui_input-container_2rhyz_1rylw_129",
  "input-field": "awsui_input-field_2rhyz_1rylw_134",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_1rylw_158",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_1rylw_173",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_1rylw_181",
  "input-field-warning": "awsui_input-field-warning_2rhyz_1rylw_195",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_1rylw_209",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_1rylw_209",
  "grouped": "awsui_grouped_2rhyz_1rylw_224",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_1rylw_234",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_1rylw_238",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_1rylw_244",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_1rylw_248",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_1rylw_252",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_1rylw_258",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_1rylw_262",
  "with-error": "awsui_with-error_2rhyz_1rylw_266",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_1rylw_294",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_1rylw_294",
  "with-warning": "awsui_with-warning_2rhyz_1rylw_300",
  "grouped-validation-first": "awsui_grouped-validation-first_2rhyz_1rylw_342",
  "input-prefix": "awsui_input-prefix_2rhyz_1rylw_349",
  "input-suffix": "awsui_input-suffix_2rhyz_1rylw_350",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1rylw_364",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1rylw_373",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1rylw_399",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1rylw_406",
  "input-button-right": "awsui_input-button-right_2rhyz_1rylw_412",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1rylw_416",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1rylw_419",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1rylw_423",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1rylw_426",
  "inline-label": "awsui_inline-label_2rhyz_1rylw_416",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1rylw_451"
};
  